/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";
import io from "socket.io-client";
import { Link } from "react-router-dom";

/*COMPONENT*/
import Modal from "../common_modal/Modal";
import EditLayer from "./EditLayer";
import DeleteLayer from "./DeleteLayer";
import DeleteLayerAttach from "./DeleteLayerAttach";
import AddRowBulk from "./AddRowBulk";
import LongPress from "../common_trivial/LongPress";

/*REDUX*/
import {
  setLayer,
  setTabelStatus,
  setEditGeometry,
  setRealtimeStatus,
  setLayerWOgeojson,
  setChatStatus,
  getDetailLayerByLinkWOgeojson,
  setViewLayer,
  set_value_layer,
} from "../../App/actions/layerActions";
import {
  migration_action,
  setDrawMode,
} from "../../App/actions/layerNewActions";
import { getDetailLayerById } from "../../App/actions/get_features_action";
import { get_pda, get_pch } from "../../App/actions/iotActions";
import { get_layer_detail_custom_api } from "../../App/actions/openApiActions";
import {
  view_layer,
  set_layer_id,
  view_heatmap,
} from "../../App/actions/dataActions";
import { set_value_toolbox } from "../../App/actions/toolboxActions";
import { openModal } from "../../App/actions/authActions";
import { set_value_properties } from "../../App/actions/propertiesActions";

/*PICTURE*/
import ICON_VIEW from "../../Assets/jsx/ICON_VIEW";
import ICON_TABLE from "../../Assets/jsx/ICON_TABLE";
import ICON_GEOMETRY from "../../Assets/jsx/ICON_GEOMETRY";
import ICON_HEATMAP from "../../Assets/jsx/ICON_HEATMAP";
import ICON_CHAT from "../../Assets/jsx/ICON_CHAT";
import EditIcon from "../common_icon/EditIcon";
import DeleteIcon from "../common_icon/DeleteIcon";
import pic_static from "../../Assets/svg/profile_pic_comment.svg";
import CIRCLE from "../../Assets/jsx/CIRCLE";

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/
const sidebar_closed = 70;
const SOCKET_URL_MAPID = "https://socket.mapid.io";
const geo_layer_status_that_editable_properties = [
  "original",
  "digitasi",
  "upload",
  "site_selection",
  "SS_MANUAL",
];
const geo_layer_status_that_editable_layer = [
  "original",
  "digitasi",
  "upload",
  "attached",
  "site_selection",
  "SS_MANUAL",
];
const geo_layer_status_that_deleteable = [
  "original",
  "digitasi",
  "upload",
  "attached",
  "site_selection",
  "SS_MANUAL",
];

class LayerListRender extends Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.interval = null;
    this.state = {
      forbiddenUsernameListForDeleteFeature: [
        "dsda.dinas",
        "dinas_SDA",
        "banjir_SDA",
        "CC_SDA",
      ],
      user: this.props.auth.user,
      modal_bounding_box: false,
      modalEdit: false,
      modalDelete: false,
      modalDeleteAttach: false,
      modalMigration: false,
      modalEditorInfo: false,
      modalEditorData: null,
      bodyMigrate: {
        geo_layer_id: "",
        user_id: "",
        geo_project_id: "",
        buttonOnStatus: { status: false, IdLayer: "" },
      },
      editorUsers: [],
      IDLayer: [],
      modal_wait_get_layer: false,
    };
    this.maxViewEditors = 3;
    this.socket = io.connect(SOCKET_URL_MAPID, {
      secure: true,
      reconnection: true,
      rejectUnauthorized: false,
    });
  }

  toggle_wait_get_layer = () => {
    this.setState({
      modal_wait_get_layer: !this.state.modal_wait_get_layer,
    });
  };

  componentDidMount() {
    this._isMounted = true;
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  }

  componentWillUnmount() {
    this._isMounted = false;
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
    clearInterval(this.interval);
  }

  toggle_bounding_box = () => {
    this.setState({
      modal_bounding_box: !this.state.modal_bounding_box,
    });
  };

  getRandomColor = () => {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  handleModalEditorUser(user) {
    const { modalEditorInfo } = this.state;
    this.setState({
      modalEditorInfo: !modalEditorInfo,
      modalEditorData: user ? user : null,
    });
  }

  handleBeforeUnload = (event) => {
    const { _id, name, email, profile_picture } = this.props.auth?.user || {};
    const user_data = { _id, name, email, profile_picture };
    this.socket.emit("from_mapid_backend", {
      data: { ...user_data },
      topic: "userDeleteAllLayer",
    });
  };

  on_fly_layer = (geo_layer_item, folder_id) => {
    this.disable_geometry();
    this.props.set_value_layer({
      key: "feature_key_selected",
      value: "",
    });

    this.props.set_value_layer({
      key: "feature_object_selected",
      value: null,
    });

    const { popup_dom } = this.props.layer;
    if (popup_dom) {
      popup_dom.remove();
      this.props.set_value_layer({
        key: "popup_dom",
        value: null,
      });
    }

    const { layer_id } = this.props.layer;

    if (geo_layer_item?.is_use_bounding_box) {
      let { layer_id_bound } = this.props.layer;
      const body = { geo_layer_id: geo_layer_item._id, value: true };
      this.props.view_layer(body);
      if (!layer_id_bound.includes(geo_layer_item?._id)) {
        layer_id_bound.push(geo_layer_item?._id);
        this.props.set_value_layer({
          key: "layer_id_bound",
          value: layer_id_bound,
        });
        this.setState({
          modal_bounding_box: true,
        });
      } else {
        layer_id_bound = layer_id_bound.filter(
          (item) => item !== geo_layer_item?._id,
        );
        this.props.set_value_layer({
          key: "layer_id_bound",
          value: layer_id_bound,
        });
      }
    } else {
      if (
        //layer yang dipilih bukanlah layer yang sedang aktif
        layer_id !== geo_layer_item._id
      ) {
        if (
          //belum ada geojson di dalam layer yang diklik, akses data dahulu
          geo_layer_item?.geojson?.features?.length === 0 ||
          !geo_layer_item?.geojson?.features
        ) {
          const { loadingProcess } = this.props.layer;

          if (loadingProcess) {
            this.setState({ modal_wait_get_layer: true });
          } else {
            if (geo_layer_item?.type_2 === "pch") {
              this.props.get_pch(geo_layer_item);
            } else if (geo_layer_item?.type_2 === "pda") {
              this.props.get_pda(geo_layer_item);
            } else {
              if (geo_layer_item?.is_custom_endpoint) {
                this.props.get_layer_detail_custom_api(geo_layer_item._id);
              } else {
                const { geo_project } = this.props.project;
                const body = {
                  geo_layer_id: geo_layer_item._id,
                  geo_project_id: geo_project._id,
                  flyStatus: true,
                  folder_id,
                  capex_value: this.props.properties.capex_value,
                  geo_layer_item,
                };
                this.props.getDetailLayerById(body);
              }
            }
          }
        } else {
          //sudah ada geojson hanya fly saja
          this.props.set_layer_id(geo_layer_item._id);
          //kemungkinan 2: sudah ada geojson, langsung toggle view
          const body = { geo_layer_id: geo_layer_item._id, value: true };
          this.props.view_layer(body);
        }
      } else {
        this.props.set_layer_id("");
      }
    }
  };

  on_view_layer = (geo_layer_item, value, folder_id) => {
    this.disable_geometry();

    this.props.set_value_layer({
      key: "feature_key_selected",
      value: "",
    });

    this.props.set_value_layer({
      key: "feature_object_selected",
      value: null,
    });

    const { popup_dom } = this.props.layer;
    if (popup_dom) {
      popup_dom.remove();
      this.props.set_value_layer({
        key: "popup_dom",
        value: null,
      });
    }

    //layer yang saat ini sedang aktif (layer yang diklik bisa jadi sama, bisa jadi beda)
    const { layer_id } = this?.props?.layer;
    const { geo_project } = this.props.project;

    if (geo_layer_item?.is_use_bounding_box) {
      let { layer_id_bound } = this.props.layer;
      const body = { geo_layer_id: geo_layer_item._id, value };
      this.props.view_layer(body);
      if (value === true) {
        layer_id_bound.push(geo_layer_item?._id);
        this.props.set_value_layer({
          key: "layer_id_bound",
          value: layer_id_bound,
        });
        this.setState({
          modal_bounding_box: true,
        });
      } else {
        layer_id_bound = layer_id_bound.filter(
          (item) => item !== geo_layer_item?._id,
        );
        this.props.set_value_layer({
          key: "layer_id_bound",
          value: layer_id_bound,
        });
      }
    } else {
      if (
        (layer_id !== geo_layer_item?._id &&
          geo_layer_item?.geojson?.features?.length === 0) ||
        !geo_layer_item?.geojson?.features
      ) {
        //kemungkinan 1: belum ada geojson, ambil geojson dulu, kemudian aktifkan view

        const { loadingProcess } = this.props.layer;

        if (loadingProcess) {
          this.setState({ modal_wait_get_layer: true });
        } else {
          if (geo_layer_item?.type_2 === "pch") {
            this.props.get_pch(geo_layer_item);
          } else if (geo_layer_item?.type_2 === "pda") {
            this.props.get_pda(geo_layer_item);
          } else {
            if (geo_layer_item?.is_custom_endpoint) {
              this.props.get_layer_detail_custom_api(geo_layer_item._id);
            } else {
              const body = {
                geo_layer_id: geo_layer_item._id,
                geo_project_id: geo_project._id,
                flyStatus: true,
                folder_id,
                capex_value: this.props.properties.capex_value,
                geo_layer_item,
              };
              this.props.getDetailLayerById(body);
            }
          }
        }
      } else {
        //kemungkinan 2: sudah ada geojson, langsung toggle view
        const body = { geo_layer_id: geo_layer_item._id, value };
        this.props.view_layer(body);
      }
      // this.handle_pre_subscribe_socket(geo_layer_item._id)
      if (value) {
        this.handle_pre_subscribe_socket(geo_layer_item._id);
      } else {
        this.handle_pre_delete_viewer(geo_layer_item._id);
      }
    }
  };

  on_view_heatmap = (geo_layer_item, value, folder_id) => {
    this.disable_geometry();

    this.props.set_value_layer({
      key: "feature_key_selected",
      value: "",
    });

    this.props.set_value_layer({
      key: "feature_object_selected",
      value: null,
    });

    const { popup_dom } = this.props.layer;
    if (popup_dom) {
      popup_dom.remove();
      this.props.set_value_layer({
        key: "popup_dom",
        value: null,
      });
    }

    //layer yang saat ini sedang aktif (layer yang diklik bisa jadi sama, bisa jadi beda)
    const { layer_id } = this?.props?.layer;

    if (geo_layer_item?.is_use_bounding_box) {
      let { layer_id_bound } = this.props.layer;
      const body = { geo_layer_id: geo_layer_item._id, value };
      this.props.view_layer(body);
      if (!layer_id_bound.includes(geo_layer_item?._id)) {
        layer_id_bound.push(geo_layer_item?._id);
        this.props.set_value_layer({
          key: "layer_id_bound",
          value: layer_id_bound,
        });
        this.setState({
          modal_bounding_box: true,
        });
      } else {
        layer_id_bound = layer_id_bound.filter(
          (item) => item !== geo_layer_item?._id,
        );
        this.props.set_value_layer({
          key: "layer_id_bound",
          value: layer_id_bound,
        });
      }
    } else {
      if (
        //kemungkinan 1: belum ada geojson, ambil geojson dulu, kemudian aktifkan view
        (layer_id !== geo_layer_item?._id &&
          geo_layer_item?.geojson?.features?.length === 0) ||
        !geo_layer_item?.geojson?.features
      ) {
        const { loadingProcess } = this.props.layer;

        if (loadingProcess) {
          this.setState({ modal_wait_get_layer: true });
        } else {
          if (geo_layer_item?.type_2 === "pch") {
            this.props.get_pch(geo_layer_item);
          } else if (geo_layer_item?.type_2 === "pda") {
            this.props.get_pda(geo_layer_item);
          } else {
            if (geo_layer_item?.is_custom_endpoint) {
              this.props.get_layer_detail_custom_api(geo_layer_item._id);
            } else {
              const { geo_project } = this.props.project;
              const body = {
                geo_layer_id: geo_layer_item._id,
                geo_project_id: geo_project._id,
                flyStatus: true,
                folder_id,
                capex_value: this.props.properties.capex_value,
                geo_layer_item,
              };
              this.props.getDetailLayerById(body);
            }
          }
        }
      } else {
        //kemungkinan 2: sudah ada geojson, langsung toggle view
        const body = { geo_layer_id: geo_layer_item._id, value };
        this.props.view_heatmap(body);
      }
      if (value === false) {
        const { map_object } = this.props.layer;
        const layer_id_heatmap = `heatmap_${geo_layer_item?._id}`;
        if (map_object.getLayer(layer_id_heatmap)) {
          map_object.removeLayer(layer_id_heatmap);
        }
        if (map_object.getSource(layer_id_heatmap)) {
          map_object.removeSource(layer_id_heatmap);
        }
      }
    }
  };

  toggle_edit_geometry = (geo_layer_item, folder_id) => {
    this.props.set_value_layer({
      key: "feature_key_selected",
      value: "",
    });

    this.props.set_value_layer({
      key: "feature_object_selected",
      value: null,
    });

    const { popup_dom } = this.props.layer;
    if (popup_dom) {
      popup_dom.remove();
      this.props.set_value_layer({
        key: "popup_dom",
        value: null,
      });
    }

    const { geometryStatus, layer_id, map_object } = this.props.layer;
    const { geo_project } = this.props.project;
    if (!geometryStatus) {
      //tidak aktif ke AKTIF
      const { type, architecture } = geo_layer_item;
      this.props.set_value_layer({
        key: "current_architecture",
        value: architecture,
      });
      this.props.set_value_layer({
        key: "current_type",
        value: type,
      });
      this.props.set_value_toolbox({
        key: "mode_draw",
        value: "simple_select",
      });
      this.handle_pre_subscribe_socket(geo_layer_item._id);
      this.props.set_value_layer({
        key: "draw_state_platform",
        value: "geometry",
      });
      const geojson = geo_layer_item?.geojson || {
        type: "FeatureCollection",
        features: [],
      };

      const draw_object = this.props.layer.draw_object;
      if (draw_object) {
        try {
          const draw_instance = Array.isArray(draw_object)
            ? draw_object[1]
            : draw_object;
          if (draw_instance) {
            draw_instance.add(geojson);
            draw_instance.changeMode("simple_select");
          }
        } catch (error) {
          console.error("MapboxDraw Geometry Error: ", error);
        }
      }

      if (map_object?.getCanvas()?.style?.cursor) {
        map_object.getCanvas().style.cursor = ""; //reset cursor
      }
    } else {
      //aktif ke TIDAK AKTIF
      this.props.set_value_layer({
        key: "draw_state_platform",
        value: "",
      });
      if (map_object?.getCanvas()?.style?.cursor) {
        map_object.getCanvas().style.cursor = ""; //reset cursor
      }

      const draw_object = this.props.layer.draw_object;

      if (draw_object) {
        try {
          const draw_instance = Array.isArray(draw_object)
            ? draw_object[1]
            : draw_object;
          if (draw_instance) {
            draw_instance.changeMode("simple_select");
            draw_instance.deleteAll();
          }
        } catch (error) {
          console.error("MapboxDraw Geometry Error: ", error);
        }
      }
    }

    if (geo_layer_item?.is_use_bounding_box) {
      let { layer_id_bound } = this.props.layer;
      if (!layer_id_bound.includes(geo_layer_item?._id)) {
        const body = { geo_layer_id: geo_layer_item._id, value: true };
        this.props.view_layer(body);
        this.setState({
          modal_bounding_box: true,
        });
        layer_id_bound.push(geo_layer_item?._id);
        this.props.set_value_layer({
          key: "layer_id_bound",
          value: layer_id_bound,
        });
      }
    } else {
      if (layer_id !== geo_layer_item._id) {
        if (!geo_layer_item?.geojson?.features?.length) {
          const { loadingProcess } = this.props.layer;

          if (loadingProcess) {
            this.setState({ modal_wait_get_layer: true });
          } else {
            if (geo_layer_item?.type_2 === "pch") {
              this.props.get_pch(geo_layer_item);
            } else if (geo_layer_item?.type_2 === "pda") {
              this.props.get_pda(geo_layer_item);
            } else {
              if (geo_layer_item?.is_custom_endpoint) {
                this.props.get_layer_detail_custom_api(geo_layer_item._id);
              } else {
                const { geo_project } = this.props.project;
                const body = {
                  geo_layer_id: geo_layer_item._id,
                  geo_project_id: geo_project._id,
                  flyStatus: true,
                  folder_id,
                  capex_value: this.props.properties.capex_value,
                  geo_layer_item,
                };
                this.props.getDetailLayerById(body);
              }
            }
          }

          this.handle_pre_subscribe_socket(geo_layer_item._id);
        } else {
          this.props.set_layer_id(geo_layer_item._id);
          this.props.setEditGeometry(!geometryStatus);
        }
      } else {
        if (!geo_layer_item?.geojson?.features?.length) {
          const { loadingProcess } = this.props.layer;

          if (loadingProcess) {
            this.setState({ modal_wait_get_layer: true });
          } else {
            const body = {
              geo_layer_id: geo_layer_item._id,
              geo_project_id: geo_project._id,
              folder_id,
              capex_value: this.props.properties.capex_value,
              geometryStatus: !geometryStatus,
              geo_layer_item,
            };
            this.props.getDetailLayerById(body);
            this.handle_pre_subscribe_socket(geo_layer_item._id);
          }
        } else {
          this.props.set_layer_id(geo_layer_item._id);
          this.props.setEditGeometry(!geometryStatus);
        }
      }
    }
  };

  toggle_edit_property = (geo_layer_item, folder_id) => {
    this.disable_geometry();

    const { is_mobile } = this.props.properties;
    if (is_mobile) {
      this.props.set_value_properties({
        key: "sidebar_left_status",
        value: false,
      });
      this.props.set_value_properties({
        key: "is_mobile_close",
        value: true,
      });
      this.props.set_value_properties({
        key: "sidebar_height",
        value: sidebar_closed,
      });
    }

    this.props.set_value_layer({
      key: "feature_key_selected",
      value: "",
    });

    this.props.set_value_layer({
      key: "feature_object_selected",
      value: null,
    });

    const { popup_dom } = this.props.layer;
    if (popup_dom) {
      popup_dom.remove();
      this.props.set_value_layer({
        key: "popup_dom",
        value: null,
      });
    }

    const { tableStatus, layer_id } = this.props.layer;

    const is_active_layer = layer_id === geo_layer_item._id;
    const is_geojson_empty =
      !geo_layer_item?.geojson?.features ||
      geo_layer_item?.geojson?.features?.length === 0;

    this.props.setTabelStatus(is_active_layer ? !tableStatus : true);
    // penyebab error legenda

    if (geo_layer_item?.is_use_bounding_box) {
      let { layer_id_bound } = this.props.layer;
      if (!layer_id_bound.includes(geo_layer_item?._id)) {
        const body = { geo_layer_id: geo_layer_item._id, value: true };
        this.props.view_layer(body);
        this.setState({
          modal_bounding_box: true,
        });
        layer_id_bound.push(geo_layer_item?._id);
        this.props.set_value_layer({
          key: "layer_id_bound",
          value: layer_id_bound,
        });
      }
    } else {
      if (is_geojson_empty) {
        const { loadingProcess } = this.props.layer;

        if (loadingProcess) {
          this.setState({ modal_wait_get_layer: true });
        } else {
          if (geo_layer_item?.type_2 === "pch") {
            this.props.get_pch(geo_layer_item);
          } else if (geo_layer_item?.type_2 === "pda") {
            this.props.get_pda(geo_layer_item);
          } else {
            if (geo_layer_item?.is_custom_endpoint) {
              this.props.get_layer_detail_custom_api(geo_layer_item._id);
            } else {
              const { geo_project } = this.props.project;
              const body = {
                geo_layer_id: geo_layer_item._id,
                geo_project_id: geo_project._id,
                flyStatus: true,
                folder_id,
                capex_value: this.props.properties.capex_value,
                geo_layer_item,
              };
              this.props.getDetailLayerById(body);
            }
          }
        }
      }
    }

    this.props.set_value_layer({
      key: "sorted_by",
      value: [
        {
          field: "id",
          sort: "asc",
        },
      ],
    });

    if (!is_active_layer || !tableStatus) {
      this.props.set_layer_id(geo_layer_item._id);
      this.handle_pre_subscribe_socket(geo_layer_item._id);
    }
  };

  toggle_chat_on_layer = (geo_layer_item) => {
    this.disable_geometry();

    this.props.set_value_layer({
      key: "feature_key_selected",
      value: "",
    });

    this.props.set_value_layer({
      key: "feature_object_selected",
      value: null,
    });

    const { popup_dom } = this.props.layer;
    if (popup_dom) {
      popup_dom.remove();
      this.props.set_value_layer({
        key: "popup_dom",
        value: null,
      });
    }

    let { geo_layer_wo_geojson, chatStatus } = this.props.layer;
    geo_layer_wo_geojson = geo_layer_wo_geojson?.geo_layer;
    if (geo_layer_wo_geojson?._id !== geo_layer_item?._id) {
      const content = {
        geo_layer: geo_layer_item,
      };
      this.props.setLayerWOgeojson(content);
      this.props.setChatStatus(true);
    } else {
      const content = {
        geo_layer: geo_layer_item,
      };
      this.props.setLayerWOgeojson(content);
      this.props.setChatStatus(!chatStatus);
    }
  };

  toggle_edit_general = (geo_layer_item) => {
    this.disable_geometry();

    this.setState({ modalEdit: !this.state.modalEdit });
    if (geo_layer_item) {
      const content = {
        geo_layer: geo_layer_item,
      };
      this.props.setLayer(content);
    }
  };

  toggle_delete_layer = (geo_layer_item) => {
    this.disable_geometry();
    if (geo_layer_item) {
      const content = {
        geo_layer: geo_layer_item,
      };
      this.props.setLayer(content);
    }
    this.setState({ modalDelete: !this.state.modalDelete });
  };

  toggle_delete_attached_layer = (geo_layer_item) => {
    this.disable_geometry();

    if (geo_layer_item) {
      const content = {
        geo_layer: geo_layer_item,
      };
      this.props.setLayer(content);
    }
    this.setState({ modalDeleteAttach: !this.state.modalDeleteAttach });
  };

  setBodyMigrate = (geo_layer_id, user_id, geo_project_id) => {
    this.setState({
      bodyMigrate: {
        geo_layer_id,
        user_id,
        geo_project_id,
      },
    });
  };

  handleCheckMarkLayers = (id) => {
    if (id) {
      let { checkedLayers } = this.props;
      const findResult = checkedLayers.findIndex((layerId) => layerId === id);
      if (findResult !== -1) {
        checkedLayers = checkedLayers.filter((layerId) => layerId !== id);
      } else {
        checkedLayers.push(id);
      }
      this.props.setCheckedLayers(checkedLayers);
    }
  };

  isIdInsideChecklistLayers = (id) => {
    let { checkedLayers } = this.props;
    const findResult = checkedLayers.find((layerId) => layerId === id);
    if (findResult) {
      return true;
    } else {
      return false;
    }
  };

  toggleModalMigration = () => {
    const { modalMigration } = this.state;
    this.setState({ modalMigration: !modalMigration });
  };

  onOpenModal = (name) => {
    this.props.openModal(name);
  };

  migration = async (e) => {
    const { bodyMigrate } = this.state;
    await this.props.migration_action(bodyMigrate);
  };

  handle_pre_subscribe_socket = (dataId) => {
    const { _id, name, full_name, email, profile_picture } =
      this.props.auth?.user;
    const user_data = {
      _id,
      name,
      full_name,
      email,
      profile_picture,
    };
    this.handle_subscribe_socket(user_data, dataId);
    this.setState({ IDLayer: [dataId] });
  };

  handle_pre_delete_viewer = (dataId) => {
    const { _id, name, email, profile_picture } = this.props.auth?.user;
    const user_data = {
      _id,
      name,
      email,
      profile_picture,
    };
    this.handle_unsubscribe_socket(user_data, dataId);
  };

  handle_subscribe_socket = (user, layerId) => {
    // document.addEventListener('mousemove', (event) => this.handleMouseMove(event, user, layerId));
    this.socket.emit("from_mapid_backend", {
      data: { ...user, idLayer: layerId, borderColor: this.getRandomColor() },
      topic: "userUpdate",
    });
    this.setState({ IDLayer: layerId });
    // this.props.onToggleCursor(user, layerId);
  };

  handle_unsubscribe_socket = (user, layerId) => {
    this.socket.emit("from_mapid_backend", {
      data: { ...user, idLayer: layerId },
      topic: "userDelete",
    });

    this.socket.off(`${layerId}`);
  };

  disable_geometry = () => {
    const { map_object } = this.props.layer;
    this.props.setEditGeometry(false);
    this.props.set_value_layer({
      key: "draw_state_platform",
      value: "",
    });
    if (map_object?.getCanvas()?.style?.cursor) {
      map_object.getCanvas().style.cursor = ""; //reset cursor
    }
    const draw_object = this.props.layer.draw_object;
    if (draw_object) {
      try {
        const draw_instance = Array.isArray(draw_object)
          ? draw_object[1]
          : draw_object;
        if (draw_instance) {
          draw_instance.changeMode("simple_select");
          draw_instance.deleteAll();
        }
      } catch (error) {
        console.error("MapboxDraw disable error: ", error);
      }
    }
  };

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;
    let mode_list = localStorage?.mode_list;

    //local state
    const {
      modalEdit,
      modalDelete,
      modalDeleteAttach,
      modalMigration,
      modalEditorInfo,
      modal_bounding_box,
      modal_wait_get_layer,
    } = this.state;
    const editorUsers = this?.state?.editorUsers || [];

    //global props
    let {
      geo_layer_wo_geojson,
      geometryStatus,
      tableStatus,
      flyStatus,
      chatStatus,
      layer_id,
      layer_id_active,
      layer_id_heatmap,
    } = this.props.layer;
    const { geo_layer_list, is_mode_checklist_layer } = this.props;
    const domain = this.props.auth.domain;
    const { mode_map } = this.props.properties;

    //content
    const modal_bounding_box_content = modal_bounding_box && (
      <Modal
        modalSize="small"
        id="modal"
        isOpen={modal_bounding_box}
        onClose={this.toggle_bounding_box}
      >
        <div className="box-body">
          <main className="text_center">
            <p className="text_bold margin_bottom">
              {
                dict?.[
                  "This layer uses get data by bounding box, zoom and pan the map to load data"
                ]?.[language]
              }
            </p>
            <img
              src="https://s3.ap-southeast-3.amazonaws.com/mapid.jakarta.public/public/bounding_box.gif"
              alt="Bounding Box"
              style={{ width: "500px", maxWidth: "100%", borderRadius: "7px" }}
            />
          </main>
        </div>
      </Modal>
    );

    const modal_wait_get_layer_content = modal_wait_get_layer && (
      <Modal
        modalSize="medium"
        id="modal"
        isOpen={modal_wait_get_layer}
        onClose={this.toggle_wait_get_layer}
      >
        <div className="box-body">
          <main className="text_center">
            <p className="text_big">Tunggu data sebelumnya termuat</p>
          </main>
        </div>
      </Modal>
    );

    if (domain === "bbwsciliwungcisadane.mapid.io") {
      if (!mode_list) {
        mode_list = "compact";
      }
    } else if (domain === "bbwsbrantas.mapid.io") {
      if (!mode_list) {
        mode_list = "compact";
      }
    } else if (
      domain === "ditjenikma.mapid.io" ||
      domain === "ditjenikma-kemenperin.mapid.io"
    ) {
      if (!mode_list) {
        mode_list = "default";
      }
    } else if (domain === "mrt.mapid.io") {
      if (!mode_list) {
        mode_list = "default";
      }
    } else {
      if (!mode_list) {
        mode_list = "default";
      }
    }

    const content = (
      <main>
        {geo_layer_list.map((layer_item, idx) => {
          const folder_id = layer_item?.folder || "";
          const status = layer_item?.status;
          const geo_layer = layer_item?.geo_layer;
          const { _id, name, user, architecture, geo_project } =
            geo_layer || {};
          const { full_name, badge } = user || {};
          const viewStatus = layer_id_active.includes(geo_layer?._id);
          const view_heatmap = layer_id_heatmap.includes(geo_layer?._id);
          const username = user?.name;

          let id_css;
          if (_id === layer_id && flyStatus) {
            id_css = "box_active";
          } else {
            id_css = "box_non_active";
          }
          let button_footer;
          let button_top;

          const addRowBulkButton = (
            <div style={{ display: "inline-block", marginRight: "5px" }}>
              <AddRowBulk geo_layer={geo_layer} />
            </div>
          );

          const editLayerButton = (
            <div
              onClick={this.toggle_edit_general.bind(this, geo_layer)}
              style={{ display: "inline-block" }}
              data-mapid={`clickEdit-${idx}`}
            >
              <EditIcon />
            </div>
          );

          const deleteLayerButton = (
            <div
              onClick={
                status === "attached"
                  ? this.toggle_delete_attached_layer.bind(this, geo_layer)
                  : this.toggle_delete_layer.bind(this, geo_layer)
              }
              style={{ display: "inline-block" }}
            >
              <DeleteIcon />
            </div>
          );

          button_top = mode_map === "editor" && (
            <section style={{ display: "inline-block", gap: "10px" }}>
              {geo_layer_status_that_editable_properties.includes(status) &&
                architecture !== "api" &&
                addRowBulkButton}
              {geo_layer_status_that_editable_layer.includes(status) &&
                editLayerButton}
              {geo_layer_status_that_deleteable.includes(status) &&
              [
                "localhost:3003",
                "dsdajakarta.mapid.io",
                "dsdajakarta-alpha.mapid.io",
                "dsdajakarta-beta.mapid.io",
              ].includes(window.location.hostname) &&
              !["dsdajakarta", "pusdatin_SDA"].includes(
                this.props.auth.user?.name?.trim(),
              ) ? (
                <></>
              ) : (
                deleteLayerButton
              )}
            </section>
          );

          button_footer = (
            <section className="layer_action_section">
              <div
                className="cursor_pointer layer_action_item"
                onClick={this.on_view_layer.bind(
                  this,
                  geo_layer,
                  !viewStatus,
                  folder_id,
                )}
                data-mapid={`clickTutupMata-${idx}`}
              >
                <ICON_VIEW
                  color={viewStatus ? "#000" : "#b7b7b7"}
                  strokeWidth={viewStatus ? 4 : 3}
                  style={{ width: "27px", height: "27px" }}
                />
                <p
                  className={`layer_action_label ${
                    viewStatus ? "active_label" : "inactive_label"
                  }`}
                >
                  {dict?.["View"]?.[language]}
                </p>
              </div>

              <button
                className="cursor_pointer layer_action_item"
                onClick={this.on_view_heatmap.bind(
                  this,
                  geo_layer,
                  !view_heatmap,
                  folder_id,
                )}
                data-mapid={`clickTutupHitMap-${idx}`}
              >
                <ICON_HEATMAP
                  color={view_heatmap ? "#000" : "#b7b7b7"}
                  strokeWidth={view_heatmap ? 4 : 3}
                  style={{ width: "27px", height: "27px" }}
                />
                <p
                  className={`layer_action_label ${
                    view_heatmap ? "active_label" : "inactive_label"
                  }`}
                >
                  {dict?.["Heatmap"]?.[language]}
                </p>
              </button>

              {geo_layer_status_that_editable_properties.includes(status) &&
                mode_map === "editor" &&
                architecture !== "api" && (
                  <div
                    className="cursor_pointer layer_action_item"
                    onClick={this.toggle_edit_geometry.bind(
                      this,
                      geo_layer,
                      folder_id,
                    )}
                    data-mapid={`clickBukaDigitasi-${idx}`}
                  >
                    <ICON_GEOMETRY
                      color={
                        _id === layer_id && geometryStatus ? "#000" : "#b7b7b7"
                      }
                      strokeWidth={_id === layer_id && geometryStatus ? 4 : 3}
                      style={{ width: "27px", height: "27px" }}
                    />
                    <p
                      className={`layer_action_label ${
                        _id === layer_id && geometryStatus
                          ? "active_label"
                          : "inactive_label"
                      }`}
                    >
                      {dict?.["Geometry"]?.[language]}
                    </p>
                  </div>
                )}

              <div
                className="cursor_pointer layer_action_item"
                onClick={this.toggle_edit_property.bind(
                  this,
                  geo_layer,
                  folder_id,
                )}
                data-mapid={`clickBukaTable-${idx}`}
              >
                <ICON_TABLE
                  color={_id === layer_id && tableStatus ? "#000" : "#b7b7b7"}
                  strokeWidth={_id === layer_id && tableStatus ? 4 : 3}
                  style={{ width: "27px", height: "27px" }}
                />
                <p
                  className={`layer_action_label ${
                    _id === layer_id && tableStatus
                      ? "active_label"
                      : "inactive_label"
                  }`}
                >
                  {dict?.["Table"]?.[language]}
                </p>
              </div>

              <div
                className="cursor_pointer layer_action_item"
                onClick={this.toggle_chat_on_layer.bind(this, geo_layer)}
              >
                <ICON_CHAT
                  color={
                    _id === geo_layer_wo_geojson?.geo_layer?._id && chatStatus
                      ? "#000"
                      : "#b7b7b7"
                  }
                  strokeWidth={
                    _id === geo_layer_wo_geojson?.geo_layer?._id && chatStatus
                      ? 4
                      : 3
                  }
                  style={{ width: "27px", height: "27px" }}
                />
                <p
                  className={`layer_action_label ${
                    _id === geo_layer_wo_geojson?.geo_layer?._id && chatStatus
                      ? "active_label"
                      : "inactive_label"
                  }`}
                >
                  {dict?.["Notes"]?.[language]}
                </p>
              </div>
            </section>
          );

          const type_content = (
            <section>
              {geo_layer?.type === "IoT" ? (
                <section style={{ fontSize: 12, marginBottom: "10px" }}>
                  {dict?.["Type"]?.[language]} :
                  <div style={{ display: "inline-block", marginLeft: "5px" }}>
                    <b> IoT </b>
                  </div>
                </section>
              ) : (
                <section className="badge_small background_grey_light outline_grey">
                  {geo_layer?.type}
                </section>
              )}
            </section>
          );

          const migration_content = (
            <div className="margin_top">
              {architecture !== "v2" &&
              architecture !== "api" &&
              process.env.REACT_APP_ARCHITECTURE === "v2" &&
              domain !== "danamas.mapid.io" ? (
                <button
                  className="buttonCenter noselect long_button_inactive"
                  style={{
                    color: `${viewStatus ? "#ffffff" : "#000000"}`,
                    backgroundColor: `${
                      viewStatus ? "#606f8dff" : "#e5eefdff"
                    }`,
                    width: "100%",
                  }}
                  onClick={() => {
                    this.toggleModalMigration();
                    this.setBodyMigrate(_id, user?._id, geo_project?._id);
                  }}
                >
                  {dict?.["Migration Layer"]?.[language]}
                </button>
              ) : (
                ""
              )}
            </div>
          );

          const final_content = (
            <main>
              <section className="flex margin_bottom">
                <div style={{ flex: 1 }}>{type_content}</div>
                <div className="flex justify_between gap_5">{button_top}</div>
              </section>

              <section>
                <p
                  className="text_bold"
                  style={{
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    cursor: "pointer",
                  }}
                  onClick={this.on_fly_layer.bind(this, geo_layer, folder_id)}
                >
                  {name}
                </p>
                {is_mode_checklist_layer && (
                  <div
                    onClick={() => {
                      this.handleCheckMarkLayers(_id);
                    }}
                    className={`pointer center_perfect border h_20 w_20 rounded_5 marginRight_0 ${
                      this.isIdInsideChecklistLayers(_id)
                        ? "bg_blue"
                        : "bg_white"
                    }`}
                  >
                    {this.isIdInsideChecklistLayers(_id) && (
                      <strong className="bold text_white">✔</strong>
                    )}
                  </div>
                )}
              </section>

              <section className="margin_bottom">
                <span className="text_small" style={{ color: "#b7b7b7" }}>
                  By{" "}
                </span>
                <span className="text_small">
                  {full_name && full_name !== "" && full_name !== "-"
                    ? full_name
                    : username}
                </span>
                <span className="text_small" style={{ color: "#b7b7b7" }}>
                  <CIRCLE
                    color={"#dedede"}
                    style={{
                      width: "5px",
                      height: "5px",
                      marginRight: "5px",
                      marginLeft: "5px",
                    }}
                  />
                  {status}
                </span>
              </section>
              <div
                style={{
                  backgroundColor: "transparent",
                  borderTop: "2px solid #e6e6e6",
                  marginTop: 19,
                  marginBottom: 13,
                }}
              />
              {button_footer}
              {migration_content}
            </main>
          );

          // xitai
          let xitai_analytic_button = null;
          if (badge === "xitai") {
            xitai_analytic_button = (
              <Link
                to={{ pathname: "https://regalia-production.up.railway.app/" }}
                target="_blank"
                rel="noopener noreferrer"
                className="button_inactive bg_blue rounded_5 text_white padding_y_2 padding_x_5 font_12 marginLeft_5"
              >
                {dict["Analytics"][language]}
              </Link>
            );
          }

          return (
            <LongPress
              key={idx}
              id={id_css}
              className="layer_box"
              delay={800}
              onLongPress={() => {
                if (!this.props.is_mode_checklist_layer) {
                  this.props.toggleIsModeChecklistLayer();
                }
                this.handleCheckMarkLayers(_id);
              }}
            >
              {final_content}
              {xitai_analytic_button}
            </LongPress>
          );
        })}
      </main>
    );

    const modalEditContent = modalEdit && (
      <Modal
        modalSize="large"
        id="modalEdit"
        isOpen={modalEdit}
        onClose={this.toggle_edit_general}
      >
        <div className="box-body">
          <EditLayer toggle_edit_general={this.toggle_edit_general} />
        </div>
      </Modal>
    );

    const modalEditorInf = modalEditorInfo && (
      <Modal
        modalSize="small"
        id="modal"
        isOpen={modalEditorInfo}
        onClose={this.handleModalEditorUser.bind(this)}
      >
        <p style={{ marginBottom: "10px" }}>List Editor </p>
        <div className="box-body">
          <div style={{ display: "flex", flexDirection: "column" }}>
            {editorUsers
              .filter(
                (user) => user.topicId === this.state.modalEditorData.idLayer,
              )[0]
              .users.map((user) => (
                <div
                  key={user._id}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <div
                    style={{
                      marginRight: "10px",
                    }}
                  >
                    <div
                      className={`photo_${user._id}`}
                      samesite="None"
                      secure="true"
                      style={{
                        height: "60px",
                        width: "60px",
                        borderRadius: "50%",
                        border: `2px solid ${user?.borderColor}`,
                        background: `url(${
                          user.profile_picture.url
                            ? user.profile_picture.url
                            : pic_static
                        }) no-repeat center center / cover`,
                      }}
                    />
                  </div>
                  <div>
                    <p>{user?.full_name}</p>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </Modal>
    );

    const modalDeleteContent = modalDelete && (
      <Modal
        modalSize="small"
        id="modal"
        isOpen={modalDelete}
        onClose={this.toggle_delete_layer}
      >
        <div className="box-body">
          <DeleteLayer toggle_delete_layer={this.toggle_delete_layer} />
        </div>
      </Modal>
    );

    const modalDeleteAttachContent = modalDeleteAttach && (
      <Modal
        modalSize="small"
        id="modal"
        isOpen={modalDeleteAttach}
        onClose={this.toggle_delete_attached_layer}
      >
        <div className="box-body">
          <DeleteLayerAttach
            toggle_delete_layer={this.toggle_delete_attached_layer}
          />
        </div>
      </Modal>
    );

    const modalMigrationContent = modalMigration && (
      <Modal
        modalSize="small"
        id="modal"
        isOpen={modalMigration}
        onClose={this.toggleModalMigration}
      >
        <main className="flex flex_col gap_20">
          <section className="text_center font_20">
            {dict["Do you really want to migrate this layer to V2?"][language]}
          </section>
          <section className="center_perfect">
            <div className="flex gap_5">
              <button
                className="button button_inactive bg_blue text_white"
                onClick={async () => {
                  await this.migration();
                  this.setState({
                    modalMigration: false,
                  });
                }}
              >
                {dict["Yes"][language]}
              </button>
              <button
                className="button button_inactive background_red text_white"
                onClick={this.toggleModalMigration}
              >
                {dict["No"][language]}
              </button>
            </div>
          </section>
        </main>
      </Modal>
    );

    return (
      <main>
        {content}
        {modalEditContent}
        {modalEditorInf}
        {modalDeleteContent}
        {modalDeleteAttachContent}
        {modalMigrationContent}
        {modal_bounding_box_content}
        {modal_wait_get_layer_content}
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  project: state.project,
  layer: state.layer,
  auth: state.auth,
  properties: state.properties,
});

export default connect(mapStateToProps, {
  setLayer,
  setTabelStatus,
  setEditGeometry,
  setRealtimeStatus,
  setLayerWOgeojson,
  setChatStatus,
  getDetailLayerByLinkWOgeojson,
  setViewLayer,
  set_value_layer,
  migration_action,
  setDrawMode,
  getDetailLayerById,
  get_pda,
  get_pch,
  get_layer_detail_custom_api,
  view_layer,
  set_layer_id,
  view_heatmap,
  set_value_toolbox,
  openModal,
  set_value_properties,
})(LayerListRender);
